/**
 * Created by mohameds on 26/6/19.
 */
import React from 'react';
import myPic from '../../public/assets/images/users/1.png';

const HappyBirthday = ({pageData = {}, settings={}}) => (
    <React.Fragment>
        <h2 className="static-title-container text-white">
            <span style={{color: pageData.title_color}}>
                {pageData.title && pageData.title}
            </span>
        </h2>
        <div className="col1-thumbnail"
            style={settings && settings.show_header ? {}: {height: '500px'}}
        >
            <img src={pageData.image ? pageData.image : myPic}
                    alt={pageData.occasion_text && pageData.occasion_text}/>
        </div>
        <div className="btn btn-lg bg-white font-26 static-body-container">
            <div className="p-3 font-32 text-blue" style={{whiteSpace: 'pre-line'}}>
                {pageData.occasion_text && pageData.occasion_text}
            </div>
        </div>
    </React.Fragment>
)
export default HappyBirthday


// WEBPACK FOOTER //
// ./src/components/agencyMonitor/HappyBirthday.js